import * as React from 'react';

// PACKAGES
import Moment from 'react-moment';

// TYPES
interface DisplayDateTimeTypes {
	children?: string | number | Date | moment.Moment;
	format?: string;
}

export const DisplayDateTimeNoParse: React.FC<DisplayDateTimeTypes> = ({ children, format = 'DD/MM/YYYY hh:mm A' }) => {
	return (
		<Moment format={format}>
			{children}
		</Moment>
	);
};

export default DisplayDateTimeNoParse;